import React, { useState, useContext } from 'react';
import { Box, makeStyles, IconButton } from '@material-ui/core';
import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded
} from '@material-ui/icons';
import { HomeComponentContainer } from './styled';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet, clsx } from '@components/Provider';
import {
  STEP_BUTTON_1,
  STEP_BUTTON_2,
  STEP_BUTTON_3,
  processImages,
  STEP_BUTTON_4
} from '../Assets';
import { MediaQuery } from '../HomePresenter';
import useUserActionLog, {
  CapaActivityType,
  Enum_Action_Button_Enum
} from '@hooks/useUserActionLog';

const HowToUse: React.FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const { md, sm } = useContext(MediaQuery);
  const {
    container,
    stepBox,
    stepButtons,
    stepButton,
    stepDetail,
    compnentContainer,
    topTitle,
    smallContainer,
    card
  } = useStyles();
  const { onInsertUserActionLogOne } = useUserActionLog();

  const handleClick = (num: number) => {
    let next = (currentStep + num) % 4;
    setCurrentStep(next);
  };

  return (
    <HomeComponentContainer
      className={compnentContainer}
      padding={sm ? '100px 16px 68px' : md ? '120px 36px' : '140px 0px'}
    >
      {/* DeskTop */}
      {!sm && (
        <>
          <CustomizedTypography
            variant="h1"
            className={topTitle}
            fontWeight="700"
            gutterBottoms={md ? 40 : 48}
          >
            제조의 시작부터 끝까지, <br />
            캐파 프로세스를 살펴보세요
          </CustomizedTypography>
          <Box className={container}>
            <Box className="leftBox">
              <Box className={stepBox}>
                <Box className={stepButtons}>
                  {steps.map((step, index) => {
                    return (
                      <CustomizedButton
                        key={index}
                        className={clsx([
                          stepButton,
                          currentStep === index ? 'selected' : ''
                        ])}
                        variant="contained"
                        color="default"
                        onClick={() => {
                          onInsertUserActionLogOne(
                            step.logId,
                            CapaActivityType.ButtonClick
                          );
                          setCurrentStep(index);
                        }}
                      >
                        <div>
                          <CustomizedTypography
                            variant="body1"
                            fontWeight="500"
                            color="textSecondary"
                          >
                            step{index + 1}
                          </CustomizedTypography>
                          <CustomizedTypography
                            variant="subtitle1"
                            fontWeight="700"
                            color="textPrimary"
                          >
                            {step.label}
                          </CustomizedTypography>
                        </div>
                        <div className="btnIcon">
                          <img
                            src={step.icon}
                            height={40}
                            alt={`step${index}`}
                          />
                        </div>
                      </CustomizedButton>
                    );
                  })}
                </Box>
              </Box>
            </Box>
            <Box className="rightBox">
              <Box className={stepDetail}>
                <IconButton
                  id="leftArrow"
                  className="iconBtn"
                  aria-label="delete"
                  disabled={currentStep === 0}
                  onClick={() => {
                    onInsertUserActionLogOne(
                      Enum_Action_Button_Enum.Landing_PROCESS_STEP_PREV,
                      CapaActivityType.ButtonClick
                    );
                    handleClick(-1);
                  }}
                >
                  <ArrowBackIosRounded />
                </IconButton>
                {steps.map((step, index) => {
                  return (
                    <React.Fragment key={index}>
                      <img
                        className={clsx([
                          currentStep === index ? 'visible' : 'hidden',
                          'detailImage'
                        ])}
                        id={`image${index}`}
                        src={step.img}
                        width="100%"
                        height="auto"
                        alt={step.label}
                      />
                    </React.Fragment>
                  );
                })}
                <IconButton
                  id="rightArrow"
                  className="iconBtn"
                  aria-label="delete"
                  disabled={currentStep === 3}
                  onClick={() => {
                    onInsertUserActionLogOne(
                      Enum_Action_Button_Enum.Landing_PROCESS_STEP_NEXT,
                      CapaActivityType.ButtonClick
                    );
                    handleClick(1);
                  }}
                >
                  <ArrowForwardIosRounded />
                </IconButton>
              </Box>
            </Box>
            <Box className="bottomText">
              {steps.map((step, index) => {
                return (
                  <React.Fragment key={index}>
                    <CustomizedTypography
                      className={currentStep === index ? 'visible' : 'hidden'}
                      variant={'h4'}
                      color="textSecondary"
                    >
                      {step.description}
                    </CustomizedTypography>
                  </React.Fragment>
                );
              })}
            </Box>
          </Box>
        </>
      )}
      {sm && (
        <Box className={smallContainer}>
          <CustomizedTypography className="smTitle">
            제조의 시작부터 끝까지, <br />
            캐파 프로세스를 살펴보세요
          </CustomizedTypography>
          {steps.map((step, index) => (
            <Box className={card} key={index}>
              <div
                className="icon"
                style={{ backgroundColor: `${step.detailTitleBackground}` }}
              >
                <img src={step.icon} alt={step.label} />
              </div>
              <div>
                <CustomizedTypography
                  className="labelText"
                  fontWeight="700"
                  gutterBottoms={8}
                >
                  {step.label}
                </CustomizedTypography>
                <CustomizedTypography
                  variant="body1"
                  color="textSecondary"
                  gutterBottoms={20}
                >
                  {step.description}
                </CustomizedTypography>
                <div className="imgContainer">
                  <img src={step.img_xs} alt={step.label} />
                </div>
              </div>
            </Box>
          ))}
        </Box>
      )}
    </HomeComponentContainer>
  );
};

export default HowToUse;

const steps = [
  {
    icon: STEP_BUTTON_1,
    img: processImages.PROCESS_STEP1_1,
    img_xs: processImages.PROCESS_STEP1_XS,
    label: '견적 요청하기',
    description: '간단한 양식에 맞춰, 3분만에 견적 요청서를 작성해보세요.',
    detailTitleBackground: '#D8E6FF',
    logId: Enum_Action_Button_Enum.Landing_PROCESS_STEP1
  },
  {
    icon: STEP_BUTTON_2,
    img: processImages.PROCESS_STEP2,
    img_xs: processImages.PROCESS_STEP2_XS,
    label: '견적서 비교하기',
    description:
      '전국 각지의 제조 전문가에게 하루 평균 7개의 견적을 받아보세요.',
    detailTitleBackground: '#BEE9E9',
    logId: Enum_Action_Button_Enum.Landing_PROCESS_STEP2
  },
  {
    icon: STEP_BUTTON_3,
    img: processImages.PROCESS_STEP3,
    img_xs: processImages.PROCESS_STEP3_XS,
    label: '직접 상담하기',
    description: '파트너에게 가공방식 및 재료에 관해 자세한 상담을 받아보세요.',
    detailTitleBackground: '#FEE5A0',
    logId: Enum_Action_Button_Enum.Landing_PROCESS_STEP3
  },
  {
    icon: STEP_BUTTON_4,
    img: processImages.PROCESS_STEP4,
    img_xs: processImages.PROCESS_STEP4_XS,
    label: '발주하기',
    description:
      '상담을 통해 제조를 위한 조건을 모두 조율 후  발주서를 발행하세요.',
    detailTitleBackground: '#F6D7FF',
    logId: Enum_Action_Button_Enum.Landing_PROCESS_STEP4
  }
];

const useStyles = makeStyles((theme) => ({
  topTitle: {
    color: colorSet.gray900,
    width: 960,
    [theme.breakpoints.down('md')]: {
      width: 888
    }
  },
  compnentContainer: {
    backgroundColor: colorSet.gray100
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '& .leftBox': {
      display: 'flex',
      flexDirection: 'column',
      gap: '80px'
    },
    '& .rightBox': {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        height: 615
      }
    },
    '& .bottomText': {
      textAlign: 'center',
      [theme.breakpoints.down('md')]: {}
    },
    '& .hidden': {
      display: 'none'
    },
    '& .visible': {
      display: 'block'
    },
    [theme.breakpoints.down('md')]: {
      gap: '16px'
    },
    [theme.breakpoints.down('sm')]: {
      gap: '100px'
    }
  },
  stepBox: {
    display: 'flex',
    gap: '24px'
  },
  stepButtons: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    '& .selected': {
      backgroundColor: colorSet.gray400,
      '& p': {
        color: colorSet.primary500
      }
    },
    [theme.breakpoints.down('md')]: {
      gap: '13px'
    }
  },
  stepButton: {
    display: 'flex',
    padding: '22px 20px',
    minHeight: 94,
    width: 228,
    borderRadius: 16,
    backgroundColor: colorSet.gray200,
    '& div': {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      '& h6': {
        whiteSpace: 'nowrap'
      }
    },
    '& .btnIcon': {
      width: 40,
      marginLeft: 'auto',
      '& img': {
        margin: '0 auto'
      }
    },
    [theme.breakpoints.down('md')]: {
      width: 212
    }
  },
  stepDetail: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    backgroundColor: colorSet.gray200,
    width: '100%',
    height: 520,
    padding: '40px 24px 0 24px',
    marginBottom: 16,
    borderRadius: 16,
    overflow: 'hidden',
    '& .iconBtn': {
      position: 'absolute',
      width: 52,
      height: 52,
      backgroundColor: colorSet.gray300,
      '&:hover': {
        color: colorSet.gray900,
        backgroundColor: colorSet.gray400
      }
    },
    '& #leftArrow': {
      left: 24,
      top: 234
    },
    '& #rightArrow': {
      right: 24,
      top: 234
    },
    '& img.detailImage': {
      position: 'absolute',
      borderRadius: 16,
      boxShadow: '0px 24px 56px 4px rgba(0, 0, 0, 0.04)'
    },
    '& #image0': {
      width: 748
    },
    '& #image1': {
      width: 748
    },
    '& #image2': {
      width: 759
    },
    '& #image3': {
      width: 728
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 24,
      '& #image0, #image1, #image2,  #image3': {
        width: 696
      }
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '40px',
      gap: '0px',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '615px',
      '& img.detailImage': {
        width: '295px',
        height: 'auto',
        position: 'absolute',
        bottom: '-101px',
        boxShadow: '0px 32px 64px 10px #0000000F, 0px 24px 48px 10px #6161610F',
        borderRadius: '8px'
      }
    }
  },
  smallContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    '& .smTitle': {
      fontSize: '28px',
      fontWeight: '700'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '32px',
    '& .icon': {
      width: 56,
      height: 56,
      paddingTop: 12,
      borderRadius: '16px',
      '& img': {
        display: 'block',
        margin: '0 auto',
        height: '32px'
      }
    },
    '& .labelText': {
      fontSize: '18px'
    },
    '& .imgContainer': {
      width: '100%',
      height: 427,
      backgroundColor: colorSet.gray200,
      borderRadius: '16px',
      padding: '32px 24px 0px 24px',
      overflow: 'hidden',
      '& img': {
        width: '100%',
        borderRadius: '12px',
        boxShadow: '0px 24px 56px 4px rgba(0, 0, 0, 0.04)'
      }
    }
  }
}));
